import { Button } from '@/shared'
import { type IServiceDec, type IChildServiceDec, type ITransferServiceDto } from '@App/types/servicesTypes'

import style from './Buttons.module.scss'

interface IProps {
    tranferredService: IChildServiceDec
    chosen: IServiceDec
    onTransferService: (dto: ITransferServiceDto) => void
}

export const Buttons = (props: IProps) => {
    const { tranferredService, chosen, onTransferService } = props
    const btnTitle = `Перенести услугу "${tranferredService.name}" в раздел "${chosen.name}"`

    const onTransferServiceHandler = () => {
        onTransferService({
            code: tranferredService.code,
            sourceId: tranferredService.parentId,
            destinationId: chosen.id
        })
    }

    return (
        <div className={style.container}>
            <Button onClick={onTransferServiceHandler}>{btnTitle}</Button>
        </div>
    )
}
